import Tools from '@/core/tools'
import Utils from '@/core/utils'

const state = {
  // 所有目录及轻量化成功的文件
  federationPlanFiles: [],
  // 合模方案的文件信息
  federationPlanFileItems: []
}
const getters = {
  federationPlanFiles: (state) => { return state.federationPlanFiles },
  // 新建合模时，展示所有文件数据树
  federationPlanFileTree: (state) => {
    const arr = Tools.deepCopy(state.federationPlanFiles)
    return Utils.listToTree(arr, false, 'id')
  },
  // 编辑合模时，需过滤掉合模方案中已选择的文件
  federationPlanEditFileTree: (state) => {
    const selectData = state.federationPlanFileItems
    const allData = state.federationPlanFiles
    const list = allData.filter((item) => {
      return item.isFolder || !selectData.some((f) => f.fileId === item.id)
    })
    return Utils.listToTree(Tools.deepCopy(list), false, 'id')
  },
  federationPlanFileItems: (state) => { return state.federationPlanFileItems },
  federationSuccessFiles: (state) => {
    return state.federationPlanFileItems.filter((file) => file.checkStatus === 'NORMAL')
  },
  federationSuccessViewTokens: (state) => {
    return state.federationPlanFileItems.filter((file) => file.checkStatus === 'NORMAL').map((f, index) => {
      return {
        modelId: `${index}_${f.fileId}_${f.viewToken}`,
        viewToken: f.viewToken,
      }
    })
  },
  federationFailFiles: (state) => {
    return state.federationPlanFileItems.filter((file) => file.checkStatus !== 'NORMAL')
  },
}
const mutations = {
  setFederationPlanFiles(state, data) {
    state.federationPlanFiles = data || []
  },
  setFederationPlanFileItems(state, data) {
    state.federationPlanFileItems = data || []
  },
}
const actions = {
  // 获取所有目录及轻量化成功的文件
  async loadAllFederationPlanFiles({ commit }, spaceId) {
    try {
      const res = await this.$api.file.federationPlanFiles(spaceId)
      commit('setFederationPlanFiles', res || [])
    } catch (error) {
      commit('setFederationPlanFiles', [])
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
